import React from "react";
import styled from "@emotion/styled";

import Slider from "components/Slider";

const getMarks = (
  min: number,
  max: number
): { label?: string | undefined; value: number }[] => {
  return [
    {
      value: min,
      label: `${min}h`,
    },
    {
      value: max,
      label: max === 24 ? "23h55" : `${max}h`,
    },
  ];
};

const StyledSlider = styled(Slider)`
  margin-right: 10px;
`;

type Props = {
  value: [number];
  onChange: Function;
  min: number;
  max: number;
};

function HourRangeSlider({
  value,
  onChange,
  min = 0,
  max = 24,
}: Props): JSX.Element {
  const [rangeValue, setValue] = React.useState(value || [9, 18]);

  function handleChange(event: any, newValue: [number]) {
    setValue(newValue);
  }

  function handleChangeCommitted() {
    onChange(rangeValue);
  }

  function handleValueLabelFormat(value: number): string {
    if (value === 24) return "23h55";

    return `${value < 10 ? "0" : ""}${value}h`;
  }

  return (
    <StyledSlider
      min={min}
      max={max}
      value={rangeValue}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommitted}
      valueLabelDisplay="auto"
      aria-labelledby="range-slider"
      valueLabelFormat={handleValueLabelFormat}
      marks={getMarks(min, max)}
    />
  );
}

export default HourRangeSlider;
